module.exports = __webpack_public_path__ + "img/bill_example.7ec0816a.png";